module.exports = __webpack_public_path__ + "d4b2d132a6bb0aac4af544df6504a60b.pdf";